module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-right-2.ca0955f1.png";